<template>
  <div id="Solutions">
    <MyHeaderPage :title="$t('crossConnects.title')" button="xc" />
    <br /><br />
    <div id="LinesList">
      <div class="listLines">
        <div class="mdl-grid" v-if="this.tab_index === 1">
          <div class="mdl-cell mdl-cell--4-col">
            <TextSearchInput
              @search="this.searchByString"
              @reset="this.resetSearchByString"
            />
          </div>
          <div
            class="mdl-cell mdl-cell--2-col"
            style="margin-right: auto"
          ></div>
          <div
            class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone"
            v-show=" tab_index !== 2"
          >
            <div class="helpText alignRight">
              <p class="textXL">{{ $t("help.generic.btnLabel") }}</p>
            </div>
          </div>
          <div style="display: flex">
            <HelpRequestBtn
              :component-name="'CrossConnectGenericIncidentForm'"
              :asset-type="'cross-connects'"
              :icon="'warning'"
              :label="$t('help.incident.formTitle')"
              :skip-duplicate-warning="true"
            />
            <HelpRequestBtn
              :component-name="'CrossConnectGenericChangeRequestForm'"
              :asset-type="'cross-connects'"
              :icon="'person'"
              :label="$t('help.changeRequest.formTitle')"
              :skip-duplicate-warning="true"
              style="margin-right: 3rem"
            />
          </div>
        </div>
        <div class="mdl-grid" v-else>
          <div class="mdl-cell mdl-cell--4-col">
            <TextSearchInput
              @search="this.searchByString"
              @reset="this.resetSearchByString"
            />
          </div>
          <div class="mdl-cell mdl-cell--2-col"></div>
        </div>
        <TabContainer>
          <template #tabs>
            <Tab
              id="tabOne"
              :label="$t('tabs.listLabel')"
              @click="this.setTab(1)"
              :class="{ 'is-active': this.tab_index === 1 }"
            ></Tab>
            <Tab
              id="tabTwo"
              :label="$t('tabs.ticketListLabel')"
              @click="this.setTab(2)"
              :class="{ 'is-active': this.tab_index === 2 }"
            ></Tab>
          </template>
          <template #content>
            <div
              class="mdl-tabs__panel"
              :class="{ 'is-active': this.tab_index === 1 }"
              v-show="this.tab_index === 1"
            >
              <div class="mdl-grid">
                <div class="mdl-cell mdl-cell--4-col">
                  <span v-if="items" class="textInfo">{{
                    $t("crossConnects.itemCount", { total_count: total_items })
                  }}</span>
                </div>
              </div>
              <List
                :list="filtered"
                :view-loader="this.viewLoader"
                :view-error="this.viewError"
                :total-page="this.total_page"
              />
            </div>
            <div
              class="mdl-tabs__panel"
              :class="{ 'is-active': this.tab_index === 2 }"
              v-show="this.tab_index === 2"
            >
              <CrossConnectTicketList
                :list="filtered"
                :view-loader="viewLoader"
                :view-error="viewError"
                :total-page="total_page"
                :total-count="total_count"
                :component-name-incident="'CrossConnectIncidentDetail'"
                :component-name-change-request="'CrossConnectChangeRequestDetail'"
                :component-name-activation="'CrossConnectActivationDetails'"
                @refresh="getTicketList"
                @change-page="onChangePage"
              />
            </div>
            <div class="mdl-grid" v-show="!this.viewLoader">
              <div class="mdl-cell mdl-cell--12-col" style="text-align: center">
                <MyLoading :viewLoader="this.viewLoader" type="" />
              </div>
            </div>
          </template>
        </TabContainer>
      </div>
    </div>
  </div>
</template>
<style scoped>
.help-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.helpText {
  margin-bottom: 10px;
}
.helpRequestButtons {
  display: flex;
  gap: 10px;
}
</style>
<script>
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MyLoading from "@/components/MyLoading.vue";
import TabContainer from "@/components/Utils/TabContainer.vue";
import Tab from "@/components/Utils/Tab.vue";
import TextSearchInput from "@/components/Search/TextSearch/TextSearchInput.vue";
import List from "@/components/CrossConnect/List.vue";
import { filterDataByColumns } from "@/services/SearchService";
import HelpRequestBtn from "@/components/Tables/HelpRequestBtn.vue";
import CrossConnectTicketList from "@/components/CrossConnect/TicketList.vue";

export default {
  name: "CrossConnect",
  components: {
    CrossConnectTicketList,
    HelpRequestBtn,
    MyLoading,
    MyHeaderPage,
    TabContainer,
    Tab,
    TextSearchInput,
    List,
  },
  data() {
    return {
      items: [],
      filtered: [],
      search_columns: ["building", "address", "name"],
      tab_index: 1,
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      viewLoader: true,
      viewError: false,
      total_items: 0,
      page_size: 10,
      total_page: 1,
      total_count: 0,
      current_page: 0,
      search_by_string_key: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    ctrlPerms(perms) {
      return this.$ctrlPermissions(perms);
    },
    searchByString(keyword) {
      this.search_by_string_key = keyword;

      this.filtered = filterDataByColumns(
        this.items,
        this.search_columns,
        this.search_by_string_key
      );

      console.log(`${this.filtered.length} items found for ${keyword}`);

      // if no results are found in cache refresh data with search params
      if (!this.filtered.length) {
        this.filtered = [];
      }

      this.total_count = this.items.length;
    },
    resetSearchByString() {
      this.search_by_string_key = "";
      if (this.tab_index === 1) {
        this.getList();
      } else {
        this.getTicketList();
      }
    },
    setTab(index) {
      this.tab_index = index;
      this.search_by_string_key = "";
      if (index === 1) {
        this.getList();
      } else {
        this.search_columns = ["subject", "cf_sold_solution"];
        this.getTicketList();
      }
    },
    getList() {
      this.viewLoader = false;
      this.filtered = [];

      const URL = "assets/v1/cross-connects";
      const self = this;

      this.axios
        .get(window.VUE_APP_MISTRA_URL + URL, {
          headers: this.he,
        })
        .then((response) => {
          self.items = response.data;
          self.filtered = response.data;
          self.total_items = response.data.length;
          self.viewLoader = true;
        })
        .catch((err) => {
          const status = err?.response?.status ?? err?.request?.status;

          self.viewLoader = true;

          if (status === 403) {
            self.items = [];
            self.filtered = [];
            return;
          }

          self.viewError = true;
          self.messageError = err.message;
          setTimeout(() => {
            self.viewError = false;
          }, 5000);
        });
    },
    getTicketList() {
      const URL = "tickets/v1/ticket-list";
      const TICKET_TYPE =
        "Incident,ChangeRequest,TechAssist,CrossConnectsSupport";

      let params = {
        asset_type: "cross-connects",
        page_size: this.page_size,
        service: TICKET_TYPE,
        page: this.current_page,
      };

      this.viewLoader = false;
      this.total_count = 0;
      const self = this;

      if (this.search_by_string_key.length > 3) {
        params = {
          ...params,
          search_by: this.search_by_string_key,
          filter_by: this.columns,
        };
      }

      this.axios
        .post(window.VUE_APP_MISTRA_URL + URL, params, {
          headers: this.he,
        })
        .then((response) => {
          self.items = response.data.data;
          self.filtered = response.data.data;
          self.total_count = response.data.count;
          self.viewLoader = true;
        })
        .catch((err) => {
          const status = err?.response?.status ?? err?.request?.status;

          if (status === 404) {
            self.viewLoader = true;
            self.items = [];
            self.filtered = [];
            return;
          }

          self.viewLoader = true;

          if (status === 403) {
            self.items = [];
            self.filtered = [];
            return;
          }

          self.viewError = true;
          self.messageError = err.message;
          setTimeout(() => {
            self.viewError = false;
          }, 5000);
        });
    },
    onChangePage(page) {
      this.current_page = page;
      if (this.tab_index === 2) {
        this.getTicketList();
      }
    },
  },
};
</script>
